module.exports = __webpack_public_path__ + "img/bg-1.ce5eff1.png";